export default __webpack_public_path__ + "static/media/upload-file.402dd332.svg";